import { BuscadorPV } from '../models/buscadorPV';
import { ConfigService } from './config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IChangePassword } from '../interfaces/IChangePassword';
import { IConfirmEmail } from '../interfaces/IConfirmarEmail';
import { Injectable } from '@angular/core';
import { IUser } from '../interfaces/IUser';
import { PedidoVentaCabecera } from '../models/pedidoVentaCabecera';
import { Usuario } from '../models/usuario';
import { BuscadorCotizacion } from '../models/buscadorCotizacion';
import { CotizacionCabecera } from '../models/cotizacionCabecera';
import { TokenService } from '../utils/token.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class CotizacionesService {

  private cotizacionesServerUri: string;
  private cotizacionesServerUri2: string;
  private apiUrl = environment.apiUrl;

  constructor(
    private httpCliente: HttpClient,
    private configService: ConfigService,
    private tokenService: TokenService
  ) {
    this.cotizacionesServerUri = this.apiUrl + '/' + this.configService.CotizacionesURI;
    this.cotizacionesServerUri2 = this.apiUrl+ '/' + this.configService.UsuarioURI2;
  }
  
  private getHeaders() {
    const authToken = this.tokenService.getAuthToken();
    const authTokenBearer = this.tokenService.getAuthTokenBearer();

    return new HttpHeaders({
      'Authorization': `Bearer ${authTokenBearer}`,      
      'PortalO2G' : `${authToken}`
    });
  }

  cCotizacion(codigo: number) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CCotizacion?codigo=' + codigo, { headers: this.getHeaders() });
  }

  cCotizacionItem(nroClienteDistribuidor: string, idSucursal: string, codigoItem: number) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CCotizacionItem?nroClienteDistribuidor=' + nroClienteDistribuidor + "&idSucursal=" + idSucursal + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }

  cCotizaciones(buscador: BuscadorCotizacion) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'CCotizaciones', buscador, { headers: this.getHeaders() });
  }
  copiarCotizacion(codigo: number) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CopiarCotizacion?codigo=' + codigo, { headers: this.getHeaders() });
  }
  mCotizacionItem(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'MCotizacionItem', cab, { headers: this.getHeaders() });
  }

  bCotizacionitem(codigoCabecera: number, codigoItem: number) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'BCotizacionItem?codigoCabecera=' + codigoCabecera + "&codigoItem=" + codigoItem, { headers: this.getHeaders() });
  }

  cListasPreciosAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, nroCliente: string, idTipoOrden: string, search: string) {
    nroCliente = nroCliente == null ? "" : nroCliente;
    
    return this.httpCliente.get(this.cotizacionesServerUri + 'CListasPreciosAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroCliente=" + nroCliente + "&idTipoOrden=" + idTipoOrden + "&search=" + search, { headers: this.getHeaders() });
  }

  cListaPrecioItemsAutocompleteSearch(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string, idTerminoPago: string, idMoneda: string, idPlanta: string, idUbicacionAlmacenamiento: string, search: string) {
    idMoneda = typeof idMoneda == 'undefined' || idMoneda == null ? "" : idMoneda
    idTerminoPago = typeof idTerminoPago == 'undefined' || idTerminoPago == null ? "" : idTerminoPago
    idPlanta = typeof idPlanta == 'undefined' || idPlanta == null ? "" : idPlanta
    idUbicacionAlmacenamiento = typeof idUbicacionAlmacenamiento == 'undefined' || idUbicacionAlmacenamiento == null ? "" : idUbicacionAlmacenamiento
    idTipoListaPrecios = typeof idTipoListaPrecios == 'undefined' || idTipoListaPrecios == null ? "" : idTipoListaPrecios
    return this.httpCliente.get(this.cotizacionesServerUri + 'CListaPrecioItemsAutocompleteSearch?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios + "&idTerminoPago=" + idTerminoPago + "&idMoneda=" + idMoneda + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&search=" + search, { headers: this.getHeaders() });
  }

  cTerminosPagoTipoListaPrecios(idPais: string, idCompania: string, idSalesOrg: string, idTipoListaPrecios: string) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CTerminosPagoTipoListaPrecios?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idTipoListaPrecios=" + idTipoListaPrecios, { headers: this.getHeaders() });
  }
  cSucursales(nroCliente: string) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CSucursales?nroCliente=' + nroCliente , { headers: this.getHeaders() });
  }
  amCotizacion(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'AMCotizacion', cab, { headers: this.getHeaders() });
  }

  guardarNroOC(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'GuardarNroOC', cab, { headers: this.getHeaders() });
  }
  cStockDisponible(idPais: string, idCompania: string, idSalesOrg: string, idDivision: string, idPlanta: string, idUbicacionAlmacenamiento: string, idRegion: string, nroClienteDistribuidor: string, idSucursal: string, idProducto: string) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CStockDisponible?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&idDivision=" + idDivision + "&idPlanta=" + idPlanta + "&idUbicacionAlmacenamiento=" + idUbicacionAlmacenamiento + "&idRegion=" + idRegion + "&nroClienteDistribuidor=" + nroClienteDistribuidor + "&idSucursal=" + idSucursal + "&idProducto=" + idProducto, { headers: this.getHeaders() });
  }

  cCotizacionRetenciones(idPais: string, idCompania: string, idSalesOrg: string, nroPedido: number) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'CCotizacionRetenciones?idPais=' + idPais + "&idCompania=" + idCompania + "&idSalesOrg=" + idSalesOrg + "&nroPedido=" + nroPedido, { headers: this.getHeaders() });
  }

  aCotizacionItem(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'ACotizacionItems', cab, { headers: this.getHeaders() });
  }

  aprobarCotizacion(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'AprobarCotizacion', cab, { headers: this.getHeaders() });
  }

  aprobarCotizacionRetenida(cab: CotizacionCabecera)
  {
    return this.httpCliente.post(this.cotizacionesServerUri + 'AprobarCotizacionRetenida', cab, { headers: this.getHeaders() });
  }

  rechazarCotizacion(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'RechazarCotizacion', cab, { headers: this.getHeaders() });
  }
  rechazar(cab: CotizacionCabecera) {
    return this.httpCliente.post(this.cotizacionesServerUri + 'Rechazar', cab, { headers: this.getHeaders() });
  }
  validarToken(token: string) {
    return this.httpCliente.get(this.cotizacionesServerUri2 + 'ValidarToken?token=' + token, { headers: { 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r' } });
  }

  pruebaMailCot(cab: number)
  {
    const formData = new FormData();

    // Agregar el archivo PDF al FormData
    //formData.append('pdf', pdfBlob, `Cotizacion-${cab}.pdf`);

    // Convertir el objeto cab a JSON y agregarlo al FormData
    formData.append('nropedido', cab.toString());

    return this.httpCliente.post(this.cotizacionesServerUri + 'PruebaMailCot', formData, { headers: this.getHeaders() });
  }

  procesarCotizacion(nroPedido: string) {
    return this.httpCliente.get(this.cotizacionesServerUri2 + 'ProcesarCotAsync?nroPedido=' + nroPedido,
       { headers: { 'X-Api-Key': 'MZBfW2V6P5HwFSbgCQE8Juaheczdn4XjARNU9T7pDtqYvGyK3r' } });
  }

  obtenerFechaEntrega(comuna: string) {
    return this.httpCliente.get(this.cotizacionesServerUri + 'ObtenerFechaEntrega?comuna=' + comuna,  { headers: this.getHeaders() });
  }
}